// local imports
import { ReactComponent as Gym } from 'assets/icons/gym.svg'
import useGetGymServiceChartData from './hooks/use-get-gym-service-data'
import DoughnutChartPage from '../../chart-molecules/DoughnutPage/DoughnutChartPage'
import StackedChart from '../../chart-molecules/StackedChart/StackedChart'
import GymServiceDist from '../../chart-templates/chartcardpage/tabs/GymServiceDist'
import { DropdownWrapper, StyledDropdown } from './styled'

export default function GymServiceCharts(props: {
  userInfo: any
  firmList: any
  startDate: Date
  endDate: Date
  selectedFirms: any
}) {
  const {
    t,
    excelData,
    chartType,
    chartTypeOptions,
    handleChartTypeChange,
    items,
    labels,
    colors,
    detailTitle,
    footerTitle,
  } = useGetGymServiceChartData(props)

  const translatedLabels = labels.map((label) => t(label))

  return (
    <GymServiceDist excelData={excelData}>
      <div className="row">
        {(props.firmList.length > 1 || props.userInfo === 'SuperAdmin') && (
          <div className="col-3 d-flex justify-content-between flex-column">
            <DropdownWrapper>
              <StyledDropdown
                appendTo="self"
                value={chartType}
                onChange={handleChartTypeChange}
                options={chartTypeOptions}
                optionLabel="value"
                optionValue="key"
              />
            </DropdownWrapper>

            <DoughnutChartPage
              icon={<Gym width={24} height={24} />}
              items={items}
              colors={colors}
              labels={translatedLabels}
              detailTitle={t(detailTitle)}
              totalNotification={items?.doughnutItems.total}
            />

            <div>
              <span style={{ fontSize: '14px' }}>{t(footerTitle)}</span>
            </div>
          </div>
        )}

        <div className={props.firmList.length > 1 || props.userInfo === 'SuperAdmin' ? 'col-9 ' : 'col-12'}>
          <StackedChart
            chartId="gymChart"
            tabIndex={5}
            colors={colors}
            labels={translatedLabels}
            checkedValue={''}
            setCheckedValue={''}
            response={items}
            userInfo={props.userInfo}
            tooltipLabel={t('dashboard.on-campus-tabs.tooltipMsg')}
          />
        </div>
      </div>
    </GymServiceDist>
  )
}
